import { render, staticRenderFns } from "./course-add-or-update.vue?vue&type=template&id=4bd48fd4&scoped=true&"
import script from "./course-add-or-update.vue?vue&type=script&lang=js&"
export * from "./course-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd48fd4",
  null
  
)

export default component.exports